"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const reactstrap_1 = require("reactstrap");
exports.ObjectToString = ({ value, className, col, }) => {
    const [open, setOpen] = react_1.useState(false);
    const modal = () => (react_1.default.createElement(reactstrap_1.Modal, { isOpen: open, toggle: () => setOpen(false) },
        react_1.default.createElement(reactstrap_1.ModalHeader, { toggle: () => setOpen(false) }, col.name),
        react_1.default.createElement(reactstrap_1.ModalBody, { className: "p-3" },
            react_1.default.createElement("code", null, JSON.stringify(value, null, 4)))));
    if (typeof value !== "object")
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "d-flex align-items-center" },
            modal(),
            react_1.default.createElement("div", { className: `${className} text-truncate p-1` }, typeof value === "object" && JSON.stringify(value, null, 2)),
            react_1.default.createElement("span", { className: "cursor-pointer", onClick: () => setOpen(true) },
                react_1.default.createElement("i", { className: "fa fa-link" })))));
};
//# sourceMappingURL=ObjectToStringComponent.js.map